/**
 * PressReleasesExtractionsApi
 *
 * Client-side wrapper for the admin press release extractions endpoint. Provides a
 * typed method to fetch all AI-extracted datapoints for a single issue
 * (`findImportantDatesByIssueId`) and returns structured TypeScript types
 * for important dates, offering terms/outcome, per-field provenance and
 * overall status. HTTP details are delegated to `ApiBase`; this module's
 * types document the expected server response shape for consumers.
 */
import { GetPressReleasesExtractionRequest } from '@finance-lab/utils/types'
import ApiBase from './Api'

const PRESS_RELEASES_EXTRACTIONS_API_PATHS = {
    // Issue-level endpoint so UI asks for exactly one issue at a time.
    ADMIN_PRESS_RELEASES_EXTRACTIONS: (issueId: string) => `/admin/pressreleasesextractions/${issueId}`,
}

class PressReleasesExtractionsApi extends ApiBase {
    async findImportantDatesByIssueId(issueId: string) {
        if (!issueId) {
            return null
        }

        return await this._getRequest<GetPressReleasesExtractionRequest>(
            PRESS_RELEASES_EXTRACTIONS_API_PATHS.ADMIN_PRESS_RELEASES_EXTRACTIONS(issueId),
        )
    }
}

export default PressReleasesExtractionsApi
